const requireAll=(r)=> {
    r.keys().forEach(r);
  };

// "Blogs BG 1.svg" is excluded from the sprite: it wraps a ~290 KB base64 PNG
// (almost half of the sprite that every page downloads for its icons) and no
// component, icon-picker entry or page references the symbol. The file itself
// is still published under resources/images/icons.
requireAll(require.context('../../resources/images/icons', true, /^(?!.*Blogs BG 1\.svg$).*\.svg$/));
